<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import KdH5Bridge from './api/KdH5Bridge'

export default {
  name: 'App',
  data () {
    return {
      bridge: new KdH5Bridge(this)
    }
  },
  created () {
    console.log('App created')
  },
  mounted () {
    console.log('App mounted')
    window.kdH5 = this.bridge
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue